import React from 'react';
import { Box, Typography, Stack, useTheme } from '@mui/material';
import BackButton from './BackButton';
import { surfaceCard } from '../../../../Shared/surfaceCard';

const JobErrorState = ({ error, onBack }) => {
	const theme = useTheme();

	return (
		<Stack spacing={2} sx={{ maxWidth: 480 }}>
			<BackButton onClick={onBack} sx={{ mb: 0 }} />
			<Box sx={{ ...surfaceCard(theme), p: 3 }}>
				<Typography color="error" fontWeight={600}>
					Something went wrong
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
					{error}
				</Typography>
			</Box>
		</Stack>
	);
};

export default JobErrorState;
